import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useResetScroll from "../../utils/useResetScroll";

export default function EmailVerification() {
  useResetScroll();

  const { verificationToken } = useParams();

  useEffect(() => {
    setTimeout(() => {
      window.location.href = `otaconnect://verify-email?token=${verificationToken}`;
    }, 500);
  }, [verificationToken]);

  return (
    <div className="w-full p-5 h-[60px] flex items-center bg-white justify-between">
      Redirected to App for Email Verification...
    </div>
  );
}
